import { generateId } from '@freelancer/datastore/testing';
import { VerificationIdType } from './verification-id-types.model';

export interface GenerateVerificationIdTypesOptions {
  readonly countryCode?: string;
  readonly hasExpiryDate?: boolean;
}

export function generateVerificationIdTypesObjects({
  countryCode = 'SG',
  hasExpiryDate = true,
}: GenerateVerificationIdTypesOptions = {}): readonly VerificationIdType[] {
  // Return the default ID types. See KycRequirement::getDefaultIdNames()
  return [
    {
      id: generateId().toString(),
      backendId: 1,
      name: 'Passport',
      hasExpiryDate,
      countryCode,
    },
    {
      id: generateId().toString(),
      backendId: 2,
      name: 'Drivers License',
      hasExpiryDate,
      countryCode,
    },
    {
      id: generateId().toString(),
      backendId: 3,
      name: 'National ID Card',
      hasExpiryDate,
      countryCode,
    },
  ];
}
